import { Link, To } from 'react-router';
import { useParentPath } from '../AppNavigation/useParentPath';
import { usePreviousPath } from '../AppNavigation/usePreviousPath';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import ArrowBack from 'assets/images/arrowBack.svg';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { useTheme } from '@mui/material/styles';
import { pxToRem } from 'src/common/utils/fonts';

type DetailsPageTitleProps = {
  title: string;
  rootLocation: {
    to: To;
    name: string;
  };
  currentLocationName: string;
};

const DetailPageBackButton = () => {
  const previousPath = usePreviousPath();
  const parentPath = useParentPath();

  return (
    <IconButton component={Link} to={previousPath ?? parentPath} data-testid="backButton">
      <ArrowBack width={pxToRem(24)} height={pxToRem(24)} />
    </IconButton>
  );
};

export const DetailPageTitle = ({
  title,
  rootLocation,
  currentLocationName,
}: DetailsPageTitleProps) => {
  const { palette } = useTheme();

  return (
    <Grid container>
      <Grid>
        <DetailPageBackButton />
      </Grid>
      <Grid sx={{ mt: 9 }}>
        <Typography variant="h2" data-testid="title">
          {title}
        </Typography>
        <Breadcrumbs
          separator="›"
          aria-label="breadcrumb"
          sx={{
            mt: -10,
            '& .MuiBreadcrumbs-separator': {
              margin: 4,
            },
          }}
        >
          <Typography variant="text5" color="text.secondary">
            <Link
              to={rootLocation.to}
              style={{ color: palette.text.secondary, textDecoration: 'none' }}
            >
              {rootLocation.name}
            </Link>
          </Typography>
          <Typography variant="text5" color="text.secondary">
            {currentLocationName}
          </Typography>
        </Breadcrumbs>
      </Grid>
    </Grid>
  );
};
